var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isShowP && !_vm.isHtml)?_c('p',[_vm._v(_vm._s(_vm.pMsg))]):_vm._e(),_vm._v(" "),(_vm.isShowP && _vm.isHtml)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$h.removeXSS(_vm.msg))}}):_vm._e(),_vm._v(" "),(_vm.isShowSlot)?_c('p',[_vm._t("default",null,{text:_vm.pMsg})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c03319","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--0-1!./src/components/common/LineClamp.vue
// module id = 9As4
// module chunks = 2